import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import injectSheet from 'react-jss';
import {DefaultTimezone, Timezones} from '@deliveriesondemand/dod-data';

import {get} from '-/util/lodash';
import {applicantNameSelector, oppositeApplicantNameSelector} from '-/selectors';
import {formatAppointmentDate, getOppositeApplicant} from '-/util/util';
import {phoneScreen} from '-/styles/utils';
import StipsService from '-/services/StipsService';

const styles = theme => ({
    container: {
        textAlign: 'center',
        fontSize: 22,
        fontWeight: 'bold',
        lineHeight: '36px',
        textDecoration: 'underline',
        paddingTop: 10
    },
    coApp: {
        textAlign: 'center',
        fontWeight: 'normal',
        fontSize: 11,
        backgroundColor: theme.colors.secondary,
        padding: '5px 6px',
        borderRadius: 5,
        lineHeight: '18px',
        display: 'inline-block',
        ...phoneScreen({
            display: 'block'
        }),
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    link: {
        color: '#fff',
        textTransform: 'uppercase'
    }
});

class StipsHeader extends Component {
    static propTypes = {
        showApplicantTypeButton: PropTypes.bool,
        saving: PropTypes.bool
    };

    static defaultProps = {
        showApplicantTypeButton: true,
        saving: false
    };

    constructor(props) {
        super(props);
        const {
            coAppUnlocked,
            applicantType,
            applicantName,
            appointmentDate
        } = props;

        this.state = {
            coAppUnlocked,
            applicantType,
            applicantName,
            appointmentDate
        };
    }

    componentWillReceiveProps(nextProps) {
        const {saving} = this.state;

        if (!saving) {
            const {
                coAppUnlocked,
                applicantType,
                applicantName,
                appointmentDate
            } = nextProps;

            this.setState({
                coAppUnlocked,
                applicantType,
                applicantName,
                appointmentDate
            });
        }
    }

    renderSwitchApplicantLink() {
        const {applicantType, coAppUnlocked} = this.state;

        if (coAppUnlocked) {
            const oppositeApplicantType = getOppositeApplicant(applicantType);
            const {oppositeApplicantName, classes = {}} = this.props;

            return (
                <div className={classes.coApp} onClick={() => StipsService.setApplicantType(oppositeApplicantType)}>
                    <a className={classes.link}>
                        Click to Upload Docs for<br />{oppositeApplicantName}
                    </a>
                </div>
            );
        }
    }

    render() {
        const {applicantName, appointmentDate} = this.state;
        const {showApplicantTypeButton, classes = {}, timezone} = this.props;

        return (
            <div className="info header-container">
                {showApplicantTypeButton && this.renderSwitchApplicantLink()}
                <div className={classes.container}>
                    <p>{applicantName}</p>
                    {appointmentDate && (
                        <p>Appt: {formatAppointmentDate(appointmentDate, timezone)}</p>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {coAppUnlocked} = state.navigation;
    const {applicantType} = state.stips;
    const {appointmentDate} = state.dealInfo;
    const rawTimezone = get(state, 'creditor.callback.timezone', DefaultTimezone);
    const timezone = Timezones[rawTimezone];
    const applicantName = applicantNameSelector(state);
    const oppositeApplicantName = oppositeApplicantNameSelector(state);
    
    return {
        coAppUnlocked,
        applicantType,
        applicantName,
        oppositeApplicantName,
        appointmentDate,
        timezone
    };
};

export default connect(mapStateToProps)(injectSheet(styles)(StipsHeader));
